import { formatDate } from "@progress/kendo-intl";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { LoadingIndicator } from "../../../core/loading-indicator.component";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { SelectField } from "../../../core/select-field.component";
import { Formik } from "formik";
import { useGetSessions } from "../../../apiclient/master/useGetSessionApi";
import { useGetRoute } from "../../../apiclient/master/useGetRouteApi";
import axios from "axios";


interface IPaymentReport { }

export const PaymentReport: React.FC = () => {
    const [reportMenu, setReportMenu] = useState<IPaymentReport[]>([]);
    const [fromDate, setFromDate] = useState<Date>(
        new Date(dayjs().add(0, "months").format("MM/DD/YYYY"))
    );
    const [toDate, setToDate] = useState<Date>(new Date());

    const [sessions, setsessionData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedsession } = useGetSessions();

    const [routes, setrouteData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedroute } = useGetRoute();
    const [selectedSession, setSelectedSession] = useState<string | null>(null);
    const [selectedRoute, setSelectedRoute] = useState<string | null>(null);

    useEffect(() => {
        if (fetchedsession) {
            const mappedsession = fetchedsession.map((modepayment: any) => ({
                value: modepayment.sessionId,
                label: modepayment.name,
            }));
            setsessionData(mappedsession);
        }
        if (fetchedroute) {
            const mappedroute = fetchedroute.map((modepayment: any) => ({
                value: modepayment.routeId,
                label: modepayment.name,
            }));
            setrouteData(mappedroute);
        }
    }, [fetchedsession, fetchedroute]);


    //  const handleGeneratePdf = async () => {
    //     try {
    //       //const response =  await GetGatePassListPdf();
    //       const response = await axios.get("https://localhost:44365/api/OldIndent/GetDeliveryNoteListById?Date=2024-10-01&SessionId=1&RouteId=1",
    //         {
    //             responseType:'blob',
    //         });

    //       console.log('Fetched Record:', response);
    //       // Create a link to download the PDF
    //       const url = window.URL.createObjectURL(new Blob([response.data]));
    //       const link = document.createElement('a');
    //       link.href = url;
    //       link.setAttribute('download', 'generated.pdf'); // Set the filename
    //       document.body.appendChild(link);
    //       link.click(); // Trigger the download
    //       document.body.removeChild(link);
    //     } catch (error) {
    //       console.error('Error generating PDF:', error);
    //     }
    //   };

    const handleGeneratePdf = async () => {
        try {
            // Construct API URL dynamically using input values
            const apiUrl = `https://localhost:44365/api/OldIndent/GetDeliveryNoteListById?Date=${dayjs(fromDate).format("YYYY-MM-DD")}&SessionId=${selectedSession}&RouteId=${selectedRoute}`;

            console.log("Fetching PDF from:", apiUrl);

            const response = await axios.get(apiUrl, {
                responseType: "blob",
            });

            // Create a link to download the PDF
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "generated.pdf"); // Set filename
            document.body.appendChild(link);
            link.click(); // Trigger download
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error generating PDF:", error);
        }
    };


    // let grid = (
    //     <Grid
    //         data={null}
    //         pageable={{ pageSizes: [10, 20, 50, 100] }}
    //         total={null}
    //         groupable={true}
    //         sortable={true}
    //         onDataStateChange={null}
    //         onExpandChange={null}
    //         expandField="expanded"
    //         columnVirtualization={false}
    //     >
    //         <GridColumn
    //             width={"350px"}
    //             field="taxName"
    //             title="Name"
    //             columnMenu={null}
    //         />
    //         <GridColumn
    //             width={"250px"}
    //             field="cgstPercentage"
    //             title=" CGST(%)"
    //             columnMenu={null}
    //         />
    //         <GridColumn
    //             width={"250px"}
    //             field="sgstPercentage"
    //             title="SGST(%)"
    //             columnMenu={null}
    //         />
    //         <GridColumn width={"250px"} field="igstPercentage" title="IGST(%)" />

    //         <GridNoRecords>
    //             <div className="mt-2" style={{ width: "100%", height: "500px" }}>
    //                 <center>
    //                     <h5>No data found</h5>
    //                 </center>
    //             </div>
    //         </GridNoRecords>
    //     </Grid>
    // );

    return (
        <Formik initialValues={{ option: '' }} onSubmit={(values) => console.log(values)}>

            <>
                <div
                    className="m-lg-3 mt-lg-1 m-4 card p-3 border-0 m-3 sw-shadow radius-15"
                    style={{ minHeight: "500px" }}
                >
                    <div className="top-sec-align row">
                        <center>
                            <h4 className="text-normal title-web mb-0 report-title-color">Payment Report</h4>
                        </center>
                    </div>
                    <div className="fade_rule"></div>
                    <div className="d-flex justify-content-between mt-4 pt-3 pb-3">
                        {/* <div>
                            <label>Search</label>
                            <input
                                type="text"
                                className="form-control ms-auto search-right-align searchBg"
                            />
                        </div> */}
                        <div className="d-flex">
                            <div className="me-2">
                                <label>select Date</label>
                                <DatePicker
                                    selectsMultiple={true}
                                    openToDate={new Date()}
                                    className="form-control ms-auto search-right-align calendarBg"
                                    value={formatDate(fromDate, "dd/MM/yyyy")}
                                    placeholderText="To"
                                    dateFormat={"dd/MM/yyyy"}
                                    onChange={([date]: any) => {
                                        setFromDate(date);
                                    }}
                                />
                            </div>
                            <div className="me-2" >
                                <label>Session</label>
                                <SelectField
                                    // label="Session"
                                    name="sessionId"
                                    options={sessions}
                                    unSelectValue={0}
                                    notifyChange={(selectedOption: any) => setSelectedSession(selectedOption?.value || null)}

                                />
                            </div>

                            <div className="me-2">
                                <label>Route</label>
                                <SelectField
                                    // label="Route"
                                    name="routeId"
                                    options={routes}
                                    unSelectValue={0}
                                    notifyChange={(selectedOption: any) => setSelectedRoute(selectedOption?.value || null)}
                                />
                            </div>

                            <div>
                                <label></label>
                                <button
                                    className="btn-primary btn search-btns mt-4"
                                    onClick={() => {
                                        handleGeneratePdf()
                                    }}
                                    type="submit"
                                >
                                    <svg width="17" height="17" viewBox="0 0 17.5 17.5">
                                        <path
                                            id="Path_magnify"
                                            data-name="Path / magnify"
                                            d="M9.5,3a6.5,6.5,0,0,1,4.94,10.73l.27.27h.79l5,5L19,20.5l-5-5v-.79l-.27-.27A6.5,6.5,0,1,1,9.5,3m0,2A4.5,4.5,0,1,0,14,9.5,4.481,4.481,0,0,0,9.5,5Z"
                                            transform="translate(-3 -3)"
                                            fill="#fff"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div className="d-flex justify-content-end">
                                <button
                                    title="Export Excel"
                                    className="export-button ms-2"
                                    // onClick={exportExcel}
                                    style={{ marginTop: "23px",marginBottom:"19px" }}
                                >
                                    Export to Excel
                                </button>
                                <button
                                    title="Export Excel"
                                    className="export-button ms-2"
                                    // onClick={exportToPDF}
                                    style={{ marginTop: "23px" ,marginBottom:"19px"}}
                                >
                                    Export to PDF
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="row col=12">
                        <div>
                            <div className="top-sec-align row">
                                <div className="d-flex justify-content-end">
                                    {/* <button title="Export Excel" className="btn m-2" onClick={null}>
                                        Export to Excel
                                    </button> */}
                                    {/* <button
                                        title="Refresh list"
                                        className="btn two m-2"
                                        onClick={() => { }}
                                    >
                                        Refresh
                                    </button> */}
                                </div>
                            </div>
                            <LoadingIndicator isLoading={false} />
                            {/* <div> {grid}</div> */}
                        </div>
                    </div>
                </div>
            </>
        </Formik>

    );
};
